import React, { useState } from 'react'
import Select from 'react-select'
import moment from 'moment'
import { Drawer, Tabs } from 'antd'

import Datepicker from "../reusable/datePicker"

import { usePet, useToggle, useListData } from '../../modules'
import SelectLabel from '../reusable/selectLabel'

const { TabPane } = Tabs

let entrySubjectTypes = ['Patient', 'Supplier', 'Other']

const NewIncome = ({ toggle, visible, onPerform }) => {
    const [amount, setAmount] = useState()
    const [account, setAccount] = useState()
    const [paidThrough, setPaidThrough] = useState()
    const [subType, setSubType] = useState({ label: 'Supplier', value: 'Supplier' })
    const [subName, setSubName] = useState()
    const [ref, setRef] = useState()
    const [notes, setNotes] = useState()
    const [string, setString] = useState()
    const [subject, setSubject] = useState()
    const [subjectName, setSubjectName] = useState()
    const [date, setDate] = useState(moment())
    const [subjects, setSubjects] = useState([])
    const [method, setMethod] = useState()
    const [methods, setMethods] = useState([])
    const [accounts, setAccounts] = useState([])

    const [sub, toggleSub] = useToggle()

    const close = () => toggle()

    const modify = e => {
        switch (e.target.name) {
            case 'amount':
                setAmount(e.target.value)
                break

            case 'notes':
                setNotes(e.target.value)
                break

            case 'ref':
                setRef(e.target.value)
                break

            case 'subject':
                setSubName(e.target.value)
                break

            default:
                break
        }
    }
    
    const [
        { loading: accLoading, error }, 
        { navigate, Paginate, page = 1, limit = 10 }
    ] = useListData('accounts', { string }, { notify: true, manual: false }, 'accounts', 100, ({ accounts: data }) => {
        let obj = {}
        
        data.forEach(acc => {
            if (!obj[acc.type])
                obj[acc.type] = []

            obj[acc.type].push({
                label: acc.name,
                value: acc._id
            })
        })

        let final = []
        for (let typ in obj) {
            final.push({
                label: typ,
                options: obj[typ]
            })
        }

        setAccounts(final)
    })

    const onComplete = ({ data }, notif, ops) => {
        onPerform()
        notif('Income has been recorded', ops('success'))
        
        setTimeout(close, 300)
    }

    usePet('paymentMethodNames', null, { notify: true, callback: ({ data }) => setMethods(data) })

    const [
        { loading: supLoading, fetch: fetchSuppliers },
        { list: suppliers = [] }
    ] = useListData('suppliers', { string }, { notify: true }, 'suppliers', 50)

    const [
        { loading: pLoading, error: pError, fetch: fetchPatients },
        { list: patients = [] }
    ] = useListData('patients', { string }, { notify: true }, 'patients', 50)

    const changeSubject = sub => {
        setSubType(sub)
        setSubName('')
        setSubject()
    }

    const search = str => {
        setString(str)

        if (subType?.label === 'Patient') {
            fetchPatients()
        } else if (subType?.label === 'Supplier') {
            fetchSuppliers()
        }
    }

    const [{ loading }, execute] = usePet('newIncome', {
        date, 
        account: account?.value, 
        amount,  
        transactions: [
            {
                method: method?.value,
                amount,
                ref,
            }
        ],
        paidThrough: paidThrough?.value, 
        subjectType: subType?.value, 
        subjectId: subject?.value, 
        subjectName, 
        ref, 
        notes
    }, { notify: true, callback: onComplete, manual: true })

    return (
        <Drawer
            closable
            maskClosable
            visible={visible}
            onClose={close}
            footer={
                <div className="w-full text-right">
                    <button disabled={ loading } onClick={execute} className="text-white hisani-btn-green-light font-medium rounded-lg text-sm px-5 py-2.5 text-center">Record Income</button>
                </div>
            }
            width="40%">
            <p className="font-extrabold text-3xl mb-0">New Income</p>
            <Tabs defaultActiveKey="1">
                <TabPane tab="Income" key="1">
                    <div className="flex flex-wrap mt-3">
                        <div className="w-full px-3 mb-1">
                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                                Date
                            </label>
                            <Datepicker value={date} onChange={setDate} />
                        </div>
                        <div className="w-full px-3 mb-1">
                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-username">
                                Income Account
                            </label>
                            <Select
                                className="mb-3"
                                value={account}
                                onChange={setAccount}
                                formatGroupLabel={ SelectLabel }
                                options={accounts}
                                placeholder="Select account type" />
                        </div>
                        <div className="w-full px-3 mb-2">
                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-1" htmlFor="grid-username">
                                Amount
                            </label>
                            <input
                                className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                id="grid-amount"
                                name="amount"
                                value={amount}
                                onChange={modify}
                                type="number"
                                placeholder="Ksh. XXXX" />
                        </div>
                        <div className="w-full px-3 mb-1">
                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-username">
                                Subject Type
                            </label>
                            <Select
                                className="mb-3"
                                value={subType}
                                onChange={changeSubject}
                                options={entrySubjectTypes.map(itm => ({ label: itm, value: itm }))}
                                placeholder="Select Subject type" />
                        </div>
                        <div className="w-full px-3 mb-1">
                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-username">
                                { (subType?.value === 'Supplier' || subType?.value === 'Patient') ? subType?.value : 'Subject' } Name
                            </label>
                            {
                                (subType?.value === 'Supplier' || subType?.value === 'Patient') ?
                                    <Select
                                        className="mb-3"
                                        onInputChange={search}
                                        value={subject}
                                        onChange={setSubject}
                                        isLoading={ supLoading || pLoading }
                                        options={ (subType?.value === 'Supplier' ? suppliers : patients).map(sub => ({ label: subType?.value === 'Supplier' ? sub.name : `${sub.name} (${ sub.ipNo ?? sub.opNo })`, value: sub._id }))}
                                        placeholder={ `Search for ${subType?.value?.toLowerCase()}`} />
                                :
                                    <input
                                        className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                        id="grid-subject"
                                        name="subject"
                                        value={subName}
                                        onChange={modify}
                                        type="text"
                                        placeholder="Subject Name" />
                            }
                        </div>
                        <div className="w-full px-3 mb-1">
                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                                Notes
                            </label>
                            <textarea
                                rows={ 4 }
                                className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                id="grid-notes"
                                name="notes"
                                value={notes}
                                onChange={modify}
                                placeholder="Notes..." />
                        </div>
                    </div>
                </TabPane>
                <TabPane tab="Payment" key="2">
                    <div className="flex flex-wrap mt-3">
                        <div className="w-full px-3 mb-1">
                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-username">
                                Paid Through
                            </label>
                            <Select
                                className="mb-3"
                                value={ paidThrough }
                                onChange={ setPaidThrough }
                                formatGroupLabel={ SelectLabel }
                                options={ accounts }
                                placeholder="Select account type" />
                        </div>
                        <div className="w-full px-3 mb-1">
                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-username">
                                Payment Method
                            </label>
                            <Select
                                className="mb-3"
                                value={method}
                                onChange={setMethod}
                                options={methods.map(method => ({ label: method, value: method, amount: 0 }))}
                                placeholder="Select payment methods" />
                        </div>
                        <div className="w-full px-3 mb-2">
                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-1" htmlFor="grid-username">
                                Reference #
                            </label>
                            <input
                                className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                id="grid-ref"
                                name="ref"
                                value={ref}
                                onChange={modify}
                                type="text"
                                placeholder="Reference" />
                        </div>
                    </div>
                </TabPane>
            </Tabs>
        </Drawer>
    )
}

export default NewIncome